module.exports = node-wifi-fixes;